import { render, staticRenderFns } from "./profile-following.vue?vue&type=template&id=24a8f99c&"
import script from "./profile-following.vue?vue&type=script&lang=js&"
export * from "./profile-following.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports